<template>
  <el-dialog v-model="show" class="login-dialog" center width="95%" :close-on-click-modal="false" :show-close="false">
    <template #title>
      <h3>未实名认证</h3>
    </template>
    <div style="color: var(--el-color-info);text-align: center;font-size: 18px">
      抱歉需要实名认证后才能兑换商品哦~
    </div>
    <template #footer>
      <div style="display: flex;justify-content: center;align-items: center">
        <el-button type="info" round size="large" style="width: 40%" @click="emit('changeModel')">
          残忍拒绝
        </el-button>
        <el-button type="danger" round size="large" style="width: 40%" @click="goToRealName">
          去认证
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import {computed, defineEmits, defineProps} from "vue";

const prop = defineProps(['href', 'dialog'])
const emit = defineEmits(['changeModel'])
const show = computed(()=>prop.dialog)
const goToRealName = () => {
  const href = encodeURIComponent(location.href)
  emit("changeModel")
  window.location.href = `http://ffp.sichuanair.com/H5web/Certification/Index?version=3.0.0.0&clientkey=6F9619FF-8B86-D011-B42D-00C04FC964FF&channeltype=JWPC&signtrue=A059AA409822C7576F5C11039DFC2B2A&return_url=${href}`
}
</script>
<style scoped lang="less">

</style>
